import { render, staticRenderFns } from "./DesignContentSettingsTabs.vue?vue&type=template&id=4072ef0f&"
import script from "./DesignContentSettingsTabs.vue?vue&type=script&lang=ts&"
export * from "./DesignContentSettingsTabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports